

















import Component from 'vue-class-component';
import LoginContainer from '@/views/authentication/login-container/LoginContainer.component';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Prop } from 'vue-property-decorator';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Action, Getter, Mutation } from 'vuex-class';
import { IS_RECAPTCHA_V2_USED, LOGIN_BY_PASSWORD, SET_AUTH_LOADING_MODE } from '@/types/authentication.types';
import { LoginRequest } from '@/models/request/LoginRequest';
import { RecaptchaNamespace } from '@/globals/recaptcha-namespace.global';

@Component({
  components: {
    LoginContainer,
  },
})
export default class LoginWithPasswordComponent extends FeedbackComponent {

  @Prop(String) public successResetPasswordMessage!: string;
  @Prop(String) public gov!: string;

  @Action(LOGIN_BY_PASSWORD, StoreNamespace.AUTHENTICATION) public loginByPassword;

  @Mutation(SET_AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public setAuthLoadingMode;

  @Getter(IS_RECAPTCHA_V2_USED, StoreNamespace.AUTHENTICATION) public isRecaptchaV2Used!: boolean;

  private loginAuth: LoginRequest = {} as LoginRequest;

  public async onLogin(recaptchaV2Response: string): Promise<void> {
    this.setAuthLoadingMode(true);

    this.loginByPassword({
      ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
      recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.LOGIN_VIA_PASSWORD),
      userId: Number(this.loginAuth.userId),
      indexNum: Number(this.loginAuth.indexNum),
      password: this.loginAuth.password,
    });
  }

}
